module.exports = __webpack_public_path__ + "static/media/ball.9a6e4bce.mp3";